import { useMutation } from '@apollo/client/react';
import { EntryKind } from 'shared/domains/apollo/generated/types';
import { RenameDocumentDocument, RenameFolderDocument } from './mutation.gql';
export const useRenameEntry = (options) => {
    const { id, type, onRenamed } = options;
    const [folderMutation, folderState] = useMutation(RenameFolderDocument, {
        onCompleted({ entries }) {
            if (onRenamed) {
                onRenamed([entries]);
            }
        },
    });
    const [documentMutation, documentState] = useMutation(RenameDocumentDocument);
    const handler = (name) => {
        if (type === EntryKind.Folder) {
            return folderMutation({ variables: { id, name } });
        }
        return documentMutation({
            variables: {
                id,
                name,
                bundleVersion: process.env.PLEDITOR_BUNDLE_VERSION,
            },
        });
    };
    const error = folderState.error || documentState.error;
    const loading = folderState.loading || documentState.loading;
    return [handler, { error, loading }];
};
